import React, { forwardRef } from "react";
import "./SidebarIconSubmenu.css";
import { Link } from "react-router-dom";

// forwardRef so the parent SidebarIcon can read offsetHeight + write
// inline top/left (the submenu lives in fixed positioning).
const SidebarIconSubmenu = forwardRef(function SidebarIconSubmenu(
  { source },
  ref
) {
  const sublinks = source["links"].map((x) => (
    <Link to={x.url} key={x.title}>
      <span className="sidebar_submenu_option" key={x.title}>
        {x.title}
        {x.badge > 0 && (
          <span className="sidebar_submenu_badge">{x.badge}</span>
        )}
      </span>
    </Link>
  ));
  return (
    <div className="sidebar_submenu_main_wrapper" ref={ref}>
      <span className="sidebar_submenu_title">{source["title"]}</span>
      {sublinks}
    </div>
  );
});

export default SidebarIconSubmenu;
